import request from "@/config/utils/request";
import { addUrlPerFix } from "@/basa/utils";

//取回密码提交
export function dealSupplierFindPwd(data) {
  return request({
    url: "/apis/sp/smc/users/signup/dealSupplierFindPwd",
    method: "post",
    data
  });
}

//取回密码提交
export function updateSupPsw(data) {
  return request({
    url: "/apis/sp/smc/updateSupPsw",
    method: "post",
    data
  });
}

export function qryApprovalStatus(data) {
  return request({
    url: "/apis/sp/bidc/qryApprovalStatus",
    method: "post",
    data
  });
}

export function returnRegisterBySup(data) {
  return request({
    url: "/apis/sp/bidc/returnRegisterBySup",
    method: "post",
    data
  });
}

export function checkSuppilerName(data) {
  return request({
    url: "/apis/sp/smc/users/signup/checkSuppilerName",
    method: "post",
    data
  });
}

export function checkDjgMainStayinfo(data) {
  return request({
    url: "/apis/sp/smc/checkDjgMainStayinfo",
    method: "post",
    data
  });
}
//供应商协同公告列表查询
export function listSupBidNotice(data) {
  return request({
    url: "/apis/sp/bidc/users/signup/listSupBidNotice",
    method: "post",
    data
  });
}

//联合采购公告列表查询
export function qryJointProNotice(data) {
  return request({
    url: "/apis/sp/smc/users/signup/qryJointProNotice",
    method: "post",
    data
  });
}
//采购、邀请公告
export function listSupOpenAndInvitationNotice(data) {
  return request({
    url: "/apis/sp/bidc/users/signup/listSupOpenAndInvitationNotice",
    method: "post",
    data
  });
}
//供应商协同公告详情查询
export function qryNoticeDetail(data) {
  return request({
    url: "/apis/sp/bidc/users/signup/qryNoticeDetail",
    method: "post",
    data
  });
}
//OAuth2.0
export function OAuth(data) {
  return request({
    url:
      addUrlPerFix(process.env.VUE_APP_BASEP_URL) +
      "/apis/basap/esi/login/iccec ",
    method: "post",
    data
  });
}
//相关公告列表查询
export function qryRelatedNoticeList(data) {
  return request({
    url: "/apis/sp/bidc/users/signup/qryRelatedNoticeList",
    method: "post",
    data
  });
}
//查询包件信息
export function queryProcessSchemeMatDetail(data) {
  return request({
    url: "/apis/sp/bidc/users/signup/queryProcessSchemeMatDetail",
    method: "post",
    data
  });
}
//单位累计金额和项目数量查询
export function qryUnitAmountAndProjectNum(data) {
  return request({
    url: "/apis/sp/bidc/users/signup/qryUnitAmountAndProjectNum",
    method: "post",
    data
  });
}

//查询寻源完成累计金额和项目数量查询
export function qryFinishedAmountAndProjectNum(data) {
  return request({
    url: "/apis/sp/bidc/users/signup/qryFinishedAmountAndProjectNum",
    method: "post",
    data
  });
}

//单位推荐协同公告列表查询
export function listOpUnitBidNotice(data) {
  return request({
    url: "/apis/sp/bidc/users/signup/listOpUnitBidNotice",
    method: "post",
    data
  });
}
/*
//查询相关公告列表
export function qryNoticeList(data) {
  return request({
    url: "/apis/sp/bidc/users/signup/qryNoticeList",
    method: "post",
    data
  });
}
*/

//通知公告
export function queryPublishedNoticeList(data) {
  return request({
    url: "/apis/sp/spcms/users/signup/cmc/noticeInfo/queryPublishedNoticeList",
    method: "post",
    data
  });
}

//通知公告详情
export function queryNoticeById(data) {
  return request({
    url: "/apis/sp/spcms/users/signup/cmc/noticeInfo/queryNoticeById",
    method: "post",
    data
  });
}

//宣传海报
export function qryPostersList(data) {
  return request({
    url: "/apis/sp/spcms/users/signup/cmc/pubcontent/qryPostersList",
    method: "post",
    data
  });
}

//轮播图点击量统计
export function updateHits(data) {
  return request({
    url: "/apis/sp/spcms/users/signup/cmc/pubcontent/updateHits",
    method: "post",
    data
  });
}

//导购类目
export function getGuideCategoryTreeList(data) {
  return request({
    url: "/apis/sp/spcms/users/signup/cmc/guidecate/getGuideCategoryTreeList",
    method: "post",
    data
  });
}

//操作指南
export function queryNoviceGuide(data) {
  return request({
    url: "/apis/sp/spcms/users/signup/cmc/noviceGuide/queryNoviceGuide",
    method: "post",
    data
  });
}

//常见问题列表
export function listFaqProblem(data) {
  return request({
    url: "/apis/sp/spcms/users/signup/hc/faqProblem/listFaqProblem",
    method: "post",
    data
  });
}

//查看常见问题详情
export function getFaqProblemById(data) {
  return request({
    url: "/apis/sp/spcms/users/signup/hc/faqProblem/getFaqProblemById",
    method: "post",
    data
  });
}

// 搜索
export function searchSupBidNotice(data) {
  return request({
    url: "/apis/sp/bidc/users/signup/searchSupNoticeNew",
    // url: "/apis/sp/bidc/users/signup/searchSupBidNotice",
    method: "post",
    data
  });
}

// 查询物资分类
export function qryMatcateryTreeList(data) {
  return request({
    url: "/apis/sp/mtc/users/signup/qryMatcateryTreeList",
    method: "post",
    data
  });
}

//用于供应商校验是否可以参与
export function qrySupJoinCheck(data) {
  return request({
    url: "apis/sp/bidc/qrySupJoinCheck",
    method: "post",
    data
  });
}
//用于供应商校验是否可以参与
export function qrySupJoinCheckNew(data) {
  return request({
    url: "apis/sp/bidc/qrySupJoinCheckNew",
    method: "post",
    data
  });
}
//用于供应商校验是否可以参与
export function getSystemCurrentTime(data) {
  return request({
    url: "apis/sp/bidc/users/signup/getSystemCurrentTime",
    method: "post",
    data
  });
}

//用于供应商校验是否可以参与
export function querySupToDoItemsQuantity(data) {
  return request({
    url: "apis/sp/bidc/querySupToDoItemsQuantity",
    method: "post",
    data
  });
}

//根据登录信息查询获取供应商信息
export function getSupInfoByLoginInfo(data) {
  return request({
    url: "/apis/sp/smc/getSupInfoByLoginInfo",
    method: "post",
    data
  });
}

//用于查询当前登录人是采购商还是供应商
/*export function qryUserPartCompanyList(data) {
  return request({
    url: "apis/sp/org/qryUserPartCompanyList",
    method: "post",
    data
  });
}*/

export function listDictByCode(data) {
  return request({
    url: "/apis/bid/common/listDictByCode",
    method: "post",
    data
  });
}

export function getMailAddress(data) {
  return request({
    url: "/apis/sp/smc/getMailAddress",
    method: "post",
    data
  });
}
